import { TriangleAlert } from 'lucide-react';
import { useRegimen } from '@/store/selectors';
import { Collapsible } from '@/components/shared/Collapsible';

/** Clinical rationale text from the engine (PSD §8.2 / TODO Task 2.13). */
export function RationaleView(): JSX.Element | null {
  const regimen = useRegimen();
  if (!regimen?.rationaleText) return null;

  return (
    <Collapsible title="Clinical rationale" defaultOpen={false}>
      <div className="rationale-content" data-testid="rationale-view">
        <p className="rationale-text">{regimen.rationaleText}</p>
        <div className="value-row">
          <span className="value-label">Confidence</span>
          <span className="value-num">{regimen.confidence}</span>
        </div>
        {regimen.overrideApplied && (
          <div className="badge badge-warn">
            <TriangleAlert size={12} strokeWidth={2} aria-hidden="true" />
            Override applied: {regimen.overrideReason}
          </div>
        )}
      </div>
    </Collapsible>
  );
}
